// eslint-disable-next-line no-unused-vars
/* global __webpack_public_path__ */
// eslint-disable-next-line no-native-reassign, no-global-assign
__webpack_public_path__ =
  process.env.NODE_ENV === "development"
    ? "/"
    : window.__ASSETS_BASE_URL__ + "/";
